import React, { useEffect, useState, useCallback } from "react";
import { ApiService } from "../../../../services/ApiService";
import { useAlert } from "react-alert";
import { SystemConfigNavbar } from "../reusedcomponent/Navbar";
// import CreateJobTitleModal from "./modal/create_subcategory";
import CreateSubcategory from "./modal/create_subcategory";
import { PageBody } from "../../../../components/loader";
import { useLoadingMessage } from "../../../../components/useLoadingMessage";
import EditSubcategory from "./modal/edit_subcategory";
import useModal from "../../../../utils/useModal";
import Modal from "react-modal";
import { ConfirmTemplate } from "../../../../components/confirm";

import { systemConfigThunk } from "../../../../store/actions/systemconfiguration/systemconfig.thunk";
import { useDispatch, useSelector } from "react-redux";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    // border: "2px solid green",
  },
};

Modal.setAppElement("#root");

export const SystemConfigSubcategory = () => {
  const { isLoading, message, updateLoader } = useLoadingMessage();
  const alert = useAlert();
  const [modalOpen, Setmodalopen] = useState(false);
  // const [jobtitless, setJobtitle] = useState([]);
  const [EditValue, setEditValue] = useState([]);
  const { modalIsOpen, openModal, closeModal } = useModal();
  const [loader, setLoader] = useState(false);
  const [searchSubCat, setSearchSubCat] = useState("");

  const openEdit = () => {
    Setmodalopen(true);
  };
  const closeEditModal = () => {
    Setmodalopen(false);
  };

  const {
    subcategories,
    requestType,
    individualRequestsCategories,
    officeRequestsCategories,
  } = useSelector((state) => state.systemConfig);
  const dispatch = useDispatch();

  const getAllSubcategories = useCallback(async () => {
    updateLoader(true, "Loading subcategories");
    setLoader(true);
    await dispatch(systemConfigThunk.getSubcategories());
    setLoader(false);
    updateLoader(false);
  }, [dispatch]);

  useEffect(() => {
    getAllSubcategories();
  }, []);

  const filterSubCategory = subcategories.filter((request) => {
    return (
      request.request_type &&
      request.request_type.name
        .toLowerCase()
        .indexOf(searchSubCat.toLowerCase()) !== -1
    );
  });

  return (
    <PageBody isLoading={isLoading} message={message}>
      <React.Fragment>
        <Modal
          isOpen={modalIsOpen}
          onRequestClose={closeModal}
          style={customStyles}
          contentLabel="assign cases modal"
        >
          <CreateSubcategory
            getAllSubcategories={getAllSubcategories}
            alert={alert}
            closeModal={closeModal}
            requestType={requestType}
            officeRequestsCategories={officeRequestsCategories}
            individualRequestsCategories={individualRequestsCategories}
          />
        </Modal>

        <Modal
          isOpen={modalOpen}
          onRequestClose={closeEditModal}
          style={customStyles}
          contentLabel="assign cases modal"
        >
          <EditSubcategory
            closeModal={closeEditModal}
            requestType={requestType}
            alert={alert}
            getAllSubcategories={getAllSubcategories}
            value={EditValue}
            officeRequestsCategories={officeRequestsCategories}
            individualRequestsCategories={individualRequestsCategories}
          />
        </Modal>

        <SystemConfigNavbar />
        <div class="row container">
          <div class="col-sm-12 col-md-12 col-xs-12">
            <div class="table-wrapper table-responsive">
              <div class="table-title">
                <div class="row">
                  <div class="col-sm-6">
                    <h2>
                      <b>REQUEST SUBCATEGORIES </b>{" "}
                    </h2>
                  </div>
                  <div class="col-sm-6">
                    <button
                      onClick={openModal}
                      class="btn nt-button-color-action trigger-btn"
                      data-toggle="modal"
                    >
                      <i class="material-icons">&#xE147;</i>{" "}
                      <span> CREATE CATEGORY</span>
                    </button>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-4"></div>
                <div className="col-md-4"></div>
                <div className="col-md-4">
                  <form class="form-inline my-2 my-lg-0 float-right">
                    <input
                      class="form-control mr-sm-2"
                      type="search"
                      placeholder="Search"
                      aria-label="Search"
                      name="search"
                      value={searchSubCat}
                      onChange={(e) => setSearchSubCat(e.target.value)}
                    />
                  </form>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-12 col-xs-12">
                  <div class="registration-form">
                    <table class="table table-bordered asset-table job-title dtMaterialDesignExample">
                      <thead>
                        <tr>
                          <th class="th-sm">NO</th>
                          <th class="th-sm">NAME</th>
                          <th class="th-sm">TYPE</th>
                          <th class="th-sm">ACTION</th>
                        </tr>
                      </thead>
                      <tbody id="job_title">
                        {filterSubCategory.map((subCat, i) => (
                          <tr key={i}>
                            <td>{i + 1}</td>
                            <td>{subCat.name}</td>
                            <td>{subCat.request_type.name}</td>
                            <td>
                              <div class="dropdown">
                                <a
                                  href="javascript:void(0)"
                                  class="dropdown-toggle card-drop arrow-none"
                                  data-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <h3 class="m-0 text-muted">
                                    <i class="fa fa-ellipsis-v"></i>
                                  </h3>
                                </a>
                                <div
                                  id="dropdown_wrapper"
                                  class="dropdown-menu dropdown-menu-right dropdown_wrapper"
                                  aria-labelledby="btnGroupDrop1"
                                >
                                  <a
                                    class="dropdown-item"
                                    onClick={() => {
                                      const request = () => {
                                        ApiService.delete(
                                          `request-categories/${subCat.id}`
                                        ).then((res) => {
                                          if (res.data.type === false) {
                                            alert.error(res.data.msg);
                                          } else if (res.data.type === true) {
                                            alert.success(res.data.msg);
                                            getAllSubcategories();
                                          }
                                        });
                                      };
                                      ConfirmTemplate(
                                        {
                                          title: "Delete Subcategory",
                                          message:
                                            "Are You Sure You Want To Delete Subcategory?",
                                        },
                                        request
                                      );
                                    }}
                                  >
                                    Delete
                                  </a>

                                  <a
                                    onClick={() => {
                                      const value = {
                                        id: subCat.id,
                                        subCategory: subCat.name,
                                        request_type: subCat.request_type,
                                      };
                                      setEditValue(value);
                                      openEdit();
                                    }}
                                    class="edit dropdown-item"
                                  >
                                    <span>Edit</span>
                                  </a>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    </PageBody>
  );
};



// WEBPACK FOOTER //
// ./src/container/dashboard/systemconfiguration/subCategory/index.js